import { LAB_CONTEXT_SET_LABORATORY } from "@/store/mutation-types";

import LaboratoryCollection from "@/collections/lab/LaboratoryCollection";

const initLaboratories = (state) => {
  if (typeof state.laboratory !== "object") {
    new Promise((resolve, reject) => {
      const laboratories = new LaboratoryCollection();

      laboratories
        .fetch()
        .then(() => {
          resolve(laboratories);
        })
        .catch((error) => {
          reject(error);
        });
    }).then((laboratories) => {
      const json = JSON.stringify(laboratories.models);

      state.laboratories = JSON.parse(json);
      window.$cookies.set("laboratory_list", json);

      if (typeof state.laboratory !== "object") {
        const default_lab = state.laboratories[0];

        state.laboratory = default_lab;
        window.$cookies.set("laboratory_context", JSON.stringify(default_lab));
      }
    });
  }
};

const returnJSON = (item) => {
  if (
    item === null ||
    item === false ||
    (typeof item === "string" && item === "")
  ) {
    return false;
  } else if (typeof item === "object" && item !== null) {
    return item;
  } else {
    try {
      item = JSON.parse(item);
      return item;
    } catch (e) {
      return false;
    }
  }
};

const state = {
  laboratory: returnJSON(window.localStorage.getItem("laboratory_context")),
  laboratories: returnJSON(window.localStorage.getItem("laboratory_list")),
};

if (window.localStorage.getItem("auth__access_token")) {
  initLaboratories(state);
}

const getters = {
  getLaboratoryContext: (state) => state.laboratory,
  getLaboratoryContextList: (state) => state.laboratories,
};

const mutations = {
  LAB_CONTEXT_SET_LABORATORY(state, laboratory) {
    state.laboratory = laboratory;
    window.localStorage.setItem(
      "laboratory_context",
      JSON.stringify(laboratory)
    );
  },
};

const actions = {
  LAB_CONTEXT_INIT: ({ state }) => {
    initLaboratories(state);
  },
  LAB_CONTEXT_SET: ({ commit }, { laboratory }) => {
    return new Promise((resolve, reject) => {
      commit(LAB_CONTEXT_SET_LABORATORY, laboratory);
      laboratory ? resolve(laboratory) : reject();
    });
  },
};

export default {
  getters,
  mutations,
  actions,
  state,
};
